export function installClarity(id) {
    window.clarity =
        window.clarity ??
            function () {
                // eslint-disable-next-line prefer-rest-params
                (window.clarity.q = window.clarity.q || []).push(arguments);
            };
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + id;
    const y = document.getElementsByTagName('script')[0];
    y.parentNode?.insertBefore(t, y);
}
export function setIdentify(account) {
    window.clarity('identify', account);
}
//# sourceMappingURL=index.js.map